import HttpUtils from '../utils/HttpUtils'

// 后端聚合接口（agg_getNetworkSummary / agg_getNetworkDailyMinerStats）返回的 peakPower 单位为 W，
// 而前端 formatPower 等公共组件按 mW 约定处理。此处在 API 适配层统一归一化为 mW，避免下游各页面重复换算。
// 注意：per-miner 接口（queryMinersNetwork / queryMinersByOwner / getMinerWithPlantInfo）由底层服务透传，
// peakPower 已是 mW，不在此归一化。
function scalePeakPowerWtoMw(obj: any) {
    if (!obj || typeof obj !== 'object') return;
    Object.keys(obj).forEach((k) => {
        if (typeof obj[k] === 'number') {
            obj[k] = obj[k] * 1000;
        }
    });
}

async function getNetworkSummary() {
    const params = {
    }
    const rsp: any = await HttpUtils.sendJsonRPC('/v1','agg_getNetworkSummary',params);
    if (rsp && !rsp.error && rsp.result?.totalPeakPower) {
        scalePeakPowerWtoMw(rsp.result.totalPeakPower);
    }
    return rsp;
}

async function getNetworkDailyMinerStats() {
    const params = {
    }
    const rsp: any = await HttpUtils.sendJsonRPC('/v1','agg_getNetworkDailyMinerStats',params);
    if (rsp && !rsp.error && Array.isArray(rsp.result?.dailyStats)) {
        rsp.result.dailyStats.forEach((d: any) => scalePeakPowerWtoMw(d?.peakPower));
    }
    return rsp;
}
async function queryOwnerStats(page?:number, limit?:number) {
    const params = {
        page:page,
        limit:limit
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryOwnerStats',params);
}

async function getOwnerStatsByAddress(address:string) {
    const params = {
        address:address
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getOwnerStatsByAddress',params);
}
async function queryMinersByOwner(minerType:number,address:string,page?:number,pageSize?:number) {
    const params = {
        owner:address,
        page:page,
        limit:pageSize,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinersDetailByOwner',params);
}
async function getUserRewardLatest30DaysDashboard(address:string) {
    const params = {
        owner:address
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getUserRewardLatest30DaysDashboard',params);
}
async function queryMinersNetwork(minerType:number,page?:number,pageSize?:number) {
    const params = {
        page:page,
        limit:pageSize,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinersNetwork',params);
}
async function getMinerWithPlantInfo(minerType:number,minerAddress:string) {
    const params = {
        address:minerAddress,
        minerType:minerType,
    }
    const rsp: any = await HttpUtils.sendJsonRPC('/v1','agg_getMinerWithPlantInfo',params);
    // lite(1)/remote(2)/energy(3) 的 per-miner peak_power 存储单位为 W，
    // 转换为 mW 对齐前端 formatPower 约定。
    // standard(4) 的 peak_power 因 provider 级单位不一致（api=mW, ShineMonitor=W），暂不转换。
    if (rsp && !rsp.error && rsp.result && (minerType === 1 || minerType === 2 || minerType === 3)) {
        if (rsp.result.miner?.peak_power != null) rsp.result.miner.peak_power *= 1000;
        if (rsp.result.miner?.power != null) rsp.result.miner.power *= 1000;
    }
    return rsp;
}
async function queryMinerDailyEnergy(minerType:number,miner_address:string,page?:number,limit?:number) {
    const params = {
        miner_address:miner_address,
        page:page,
        limit:limit,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinerDailyEnergy',params);
}
async function queryMinerDailyReward(minerType:number,miner_address:string,page?:number,limit?:number) {
    const params = {
        miner_address:miner_address,
        page:page,
        limit:limit,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinerDailyReward',params);
}
async function getMinerDailyData(minerType:number,miner_address:string) {
    const params = {
        minerAddress:miner_address,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getMinerDailyData',params);
}
async function queryAddress(address:string) {
    const params = {
        address:address,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryAddress',params);
}
async function queryPlantWithImages(page?:number,limit?:number) {
    const params = {
        page:page,
        limit:limit,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryPlantWithImages',params);
}
async function getPlantInfoByType(plantType:number,plantAddress:string) {
    const params = {
        plantType:plantType,
        plantAddress:plantAddress,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getPlantInfoByType',params);
}
async function queryPlantEnergyRecords(plantType:number,plantAddress:string,page?:number,limit?:number) {
    const params = {
        plantType:plantType,
        plantAddress:plantAddress,
        page:page,
        limit:limit,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryPlantEnergyRecords',params);
}
const DataAggregatorApi ={
    getNetworkSummary:getNetworkSummary,
    getNetworkDailyMinerStats:getNetworkDailyMinerStats,
    queryOwnerStats:queryOwnerStats,
    getOwnerStatsByAddress:getOwnerStatsByAddress,
    queryMinersByOwner:queryMinersByOwner,
    getUserRewardLatest30DaysDashboard:getUserRewardLatest30DaysDashboard,
    queryMinersNetwork:queryMinersNetwork,
    getMinerWithPlantInfo:getMinerWithPlantInfo,
    queryMinerDailyEnergy:queryMinerDailyEnergy,
    queryMinerDailyReward:queryMinerDailyReward,
    getMinerDailyData:getMinerDailyData,
    queryAddress:queryAddress,
    queryPlantWithImages:queryPlantWithImages,
    getPlantInfoByType:getPlantInfoByType,
    queryPlantEnergyRecords:queryPlantEnergyRecords
}

export default DataAggregatorApi;
